import * as Sentry from "@sentry/browser";

angular
  .module("AccountingBoxApp")
  .controller("LoginCtrl", function(
    $scope,
    User,
    $location,
    Auth,
    $rootScope,
    $state,
    Company,
    $window
  ) {
    $scope.user = {};
    $scope.errors = {};
    $scope.passwordReset = false;

    $window.document.title = 'Inloggen - AdministratieBox';

    // var qs = $location.search();
    //
    // if (qs.o) {
    //   // alert( qs.o);
    //   ga("set", "dimension1", qs.o);
    // }

    if ($location.search().email) {
      $scope.user.email = $location.search().email;
    }

    $scope.resetPassword = function(user) {
      var options = {
        email: user.email
      };
      User.resetPassword(options, function() {
        $scope.passwordReset = true;
      });
    };

    $scope.login = function(form) {
      $scope.submitted = true;
      if (form.$valid) {
        $scope.loginResult = User.login(
          {
            email: $scope.user.email,
            password: $scope.user.password
          },
          function(login) {
            Auth.setCurrentUser(login.user);
            Sentry.setUser({
              name: login.user.name,
              username: login.user.name,
              email: login.user.email,
              id: login.user.id
            });
            if (login.user.isBookkeeper) {
              const nextAfterLogin = window.sessionStorage.getItem('nextAfterLogin')
              if (nextAfterLogin) {
                window.sessionStorage.removeItem('nextAfterLogin');
                return $location.url(nextAfterLogin);
              }
              return $state.go("app.bookkeeper.companies");
            }

            Company.findOne(
              {
                filter: {
                  where: {
                    id: login.user.companyId
                  },
                  include: "users"
                }
              },
              function(company) {
                $rootScope.currentCompany = company;
                if (!company.registrationDate) {
                  $rootScope.editSettings(company, true);
                }
                // console.log('send analytics');
                $rootScope.sendAnalytics();
                // console.log('analytics.track');
                analytics.track("Logged In");
                // console.log('analytics.track done');

                const nextAfterLogin = window.sessionStorage.getItem('nextAfterLogin')
                if (nextAfterLogin) {
                  window.sessionStorage.removeItem('nextAfterLogin');
                  return $location.url(nextAfterLogin);
                }
                // console.log('$state.go("app.company.dashboard", {',company.slug);
                $state.go("app.company.dashboard", {
                  companySlug: company.slug
                });
              }
            );
          },
          function(err) {
            analytics.track("Failed Login", {
              error: err.data && err.data.error
            });
            console.log(err);
            if (!err.data) {
              return ($scope.errors.other = "Inloggen is mislukt.");
            }
            if (err.data.error.code === "LOGIN_FAILED") {
              $scope.errors.other = "Onjuiste inloggegevens.";
            } else if (
              err.data.error.code === "LOGIN_FAILED_EMAIL_NOT_VERIFIED"
            ) {
              $scope.errors.other = "Het e-mailadres is nog niet bevestigd.";
            } else {
              $scope.errors.other = err.data.error.message;
            }
          }
        );
      }
    };

    var propsPrefix = "AB-";

    function save(storage, name, value) {
      var key = propsPrefix + name;
      if (value === null) value = "";
      storage[key] = JSON.stringify(value);
    }
  });
